module.exports = __webpack_public_path__ + "img/edit-icon-4.820b9892.png";